type localesKeys__Interview = {
    composer__tipDescription: string;
    composer__tipText: string;
    
    confirmDialog__resetWarningTitle: string;
    confirmDialog__resetWarningText: string;
    confirmDialog__resetWarningLowLimitText: string;
    confirmDialog__cancelButton: string;
    confirmDialog__confirmButton: string;

    emoji__labelGreeting: string;
    emoji__labelWaiting: string;
    emoji__labelSmiling: string;
    emoji__labelBored: string;
    emoji__labelThinking_1: string;
    emoji__labelThinking_2: string;
    emoji__labelThinking_3: string;
    emoji__labelThinking_4: string;
    emoji__labelEureka: string;
    emoji__labelSatisfied: string;
    emoji__labelDefault: string;

    interviewHeader__resetButton: string;
    interviewHeader__tokensLabel: string;

    interviewChat__messageAboutReseted: string;

    authRequiredModal__title: string;
    authRequiredModal__intro: string;
    authRequiredModal__rules: string;
    authRequiredModal__authWarning: string;
    authRequiredModal__loginButton: string;
    authRequiredModal__closeButton: string;
    authRequiredModal__loginError: string;
}

const ruLocale__Interview: localesKeys__Interview = {
    composer__tipDescription: 'Этот режим не заменяет реальное собеседование и не оценивает практические навыки.',
    composer__tipText: 'Спросите о моем опыте, стеке или проектах',
    
    confirmDialog__resetWarningTitle: 'Начать новую беседу?',
    confirmDialog__resetWarningText: 'Текущая беседа завершится, и мы начнем заново. Это не вернет уже израсходованный лимит.',
    confirmDialog__resetWarningLowLimitText: 'Остатка лимита может уже не хватить на следующий полноценный ответ.',
    confirmDialog__cancelButton: 'Отмена',
    confirmDialog__confirmButton: 'Начать заново',

    emoji__labelGreeting: 'Приветствую',
    emoji__labelWaiting: 'Жду вопрос',
    emoji__labelSmiling: 'Готов к диалогу',
    emoji__labelBored: 'Скучаю',
    emoji__labelThinking_1: 'Думаю...',
    emoji__labelThinking_2: 'Думаю...',
    emoji__labelThinking_3: 'Думаю...',
    emoji__labelThinking_4: 'Думаю...',
    emoji__labelEureka: 'Понял!',
    emoji__labelSatisfied: 'Доволен',
    emoji__labelDefault: 'Готов',

    interviewHeader__resetButton: 'Начать заново',
    interviewHeader__tokensLabel: 'Использовано токенов',
    interviewChat__messageAboutReseted: 'Беседа начата заново.',

    authRequiredModal__title: 'Виртуальное собеседование',
    authRequiredModal__intro: 'В этом разделе я организовал скромный RAG на базе моего опыта, карьеры, проектов и стэка. Все, что не требует от меня верификации навыка вы можете спросить тут заранее, возможно это сэкономит вам время, а может просто позабавит.',
    authRequiredModal__rules: 'У сессии есть лимит сообщений и токенов. Диалог можно занулять и начинать заново для очистки контекста, но лимиты сбрасываться не будут. Также, если вам захочется испытать чат на прочность, то милости прошу, но в случае неудачи, после 2-3 страйков вы будете заблокированы.',
    authRequiredModal__authWarning: 'Чтобы продолжить, нужно авторизоваться. Для этого мне понадобится от вас, чтобы вы представились, а именно Email и название вашей компании.',
    authRequiredModal__loginButton: 'Войти',
    authRequiredModal__closeButton: 'Закрыть',
    authRequiredModal__loginError: 'Не удалось перейти к авторизации. Сервер авторизации недоступен или его настройки не позволяют войти с этого адреса. Попробуйте позже или обновите страницу.',
};

const enLocale__Interview: localesKeys__Interview = {
    composer__tipDescription: 'This mode does not replace real interviews and does not evaluate practical skills.',
    composer__tipText: 'Ask me about my experience, tech stack or projects',
    
    confirmDialog__resetWarningTitle: 'Start a new conversation?',
    confirmDialog__resetWarningText: 'The current conversation will end and we will start over. This will not restore the already spent limit.',
    confirmDialog__resetWarningLowLimitText: 'The remaining limit may not be enough for the next full response.',
    confirmDialog__cancelButton: 'Cancel',
    confirmDialog__confirmButton: 'Start over',

    emoji__labelGreeting: 'Greeting',
    emoji__labelWaiting: 'Waiting for a question',
    emoji__labelSmiling: 'Ready for dialogue',
    emoji__labelBored: 'Bored',
    emoji__labelThinking_1: 'Thinking...',
    emoji__labelThinking_2: 'Thinking...',
    emoji__labelThinking_3: 'Thinking...',
    emoji__labelThinking_4: 'Thinking...',
    emoji__labelEureka: 'Got it!',
    emoji__labelSatisfied: 'Satisfied',
    emoji__labelDefault: 'Ready',

    interviewHeader__resetButton: 'Start over',
    interviewHeader__tokensLabel: 'Tokens used',
    interviewChat__messageAboutReseted: 'Conversation has been reset.',

    authRequiredModal__title: 'Virtual interview',
    authRequiredModal__intro: 'In this section I\'ve set up a modest RAG based on my experience, career, projects and tech stack. Anything that doesn\'t require me to verify a skill in person — feel free to ask here in advance. It might save you some time, or just be fun.',
    authRequiredModal__rules: 'The session has message and token limits. You can reset the conversation and start over to clear the context, but the limits won\'t be refreshed. Also, if you feel like stress-testing the chat — you\'re welcome to try, but after 2–3 strikes you\'ll be blocked.',
    authRequiredModal__authWarning: 'To continue, you need to sign in. For that I\'ll need you to introduce yourself — specifically your email and your company name.',
    authRequiredModal__loginButton: 'Sign in',
    authRequiredModal__closeButton: 'Close',
    authRequiredModal__loginError: 'Failed to proceed to sign-in. The auth server is unavailable or its settings don\'t allow login from this address. Please try later or refresh the page.',
};

export { ruLocale__Interview, enLocale__Interview };
export type { localesKeys__Interview };